exports = module.exports = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._3duwR-iGj68y2WBirLKjyH.PBF1tRQfoxvzmcVaB9tcH,._3duwR-iGj68y2WBirLKjyH._3WIeoe14pnyD6ERBXUhiiu{font-size:12px}._3duwR-iGj68y2WBirLKjyH._3x_e8YARvgxEQYgxKUS3rW,._3duwR-iGj68y2WBirLKjyH._3WIeoe14pnyD6ERBXUhiiu._2gnZMbuhQS3dDr2iWRY5uM{font-size:14px}._37JsJcoM2Uaj6XZ8M8k7Hf.PBF1tRQfoxvzmcVaB9tcH,._37JsJcoM2Uaj6XZ8M8k7Hf._3WIeoe14pnyD6ERBXUhiiu{font-size:11px}._37JsJcoM2Uaj6XZ8M8k7Hf._3x_e8YARvgxEQYgxKUS3rW{font-size:12px}", ""]);
// Exports
exports.locals = {
	"messageListMajorTextNext": "_3duwR-iGj68y2WBirLKjyH",
	"compact": "PBF1tRQfoxvzmcVaB9tcH",
	"medium": "_3WIeoe14pnyD6ERBXUhiiu",
	"full": "_3x_e8YARvgxEQYgxKUS3rW",
	"firstLineText": "_2gnZMbuhQS3dDr2iWRY5uM",
	"messageListMinorTextNext": "_37JsJcoM2Uaj6XZ8M8k7Hf"
};